module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/mailto-26edb51cbaaea616d80bd075b7471029.svg";